import { isMobile } from 'react-device-detect';

export const MEETING_STATE_IDLE = 'MEETING_STATE_IDLE';
export const MEETING_STATE_JOINING = 'MEETING_STATE_JOINING';
export const MEETING_STATE_JOINED = 'MEETING_STATE_JOINED';
export const MEETING_STATE_ERROR = 'MEETING_STATE_ERROR';

export const MAX_PARTICIPANTS_SHOW = isMobile ? 4 : 8;
